{
  "web": {
    "desktopTitle": "REPAS est une app mobile",
    "desktopMessage": "Scanne ce code avec l’appareil photo de ton téléphone.",
    "desktopQrLabel": "QR code vers app.repaschallenge.ch"
  },
  "common": {
    "ok": "OK",
    "cancel": "Annuler",
    "close": "Fermer",
    "back": "Retour",
    "validate": "Valider",
    "send": "Envoyer",
    "errorTitle": "Erreur",
    "genericErrorMessage": "Une erreur est survenue. Réessaie plus tard.",
    "pointsShort": "{{points}} pts",
    "continue": "Continuer",
    "later": "Plus tard",
    "loading": "Chargement...",
    "validation": {
      "emailRequired": "L’adresse e-mail est requise",
      "emailInvalid": "Adresse e-mail invalide",
      "passwordRequired": "Le mot de passe est requis",
      "passwordMinLength": "Le mot de passe doit contenir au moins 8 caractères",
      "passwordUppercase": "Le mot de passe doit contenir au moins une majuscule",
      "passwordLowercase": "Le mot de passe doit contenir au moins une minuscule",
      "passwordDigit": "Le mot de passe doit contenir au moins un chiffre",
      "fieldRequired": "{{field}} est requis",
      "fieldMinLength": "{{field}} doit contenir au moins 2 caractères",
      "fieldLettersOnly": "{{field}} ne peut contenir que des lettres",
      "genericFieldLabel": "Ce champ",
      "postalCodeFieldLabel": "Le code postal",
      "companyFieldLabel": "L’entreprise",
      "termsRequired": "Acceptation des conditions générales requise"
    },
    "supabaseErrors": {
      "invalidCredentials": {
        "title": "Connexion impossible",
        "message": "Adresse e-mail ou mot de passe incorrect. Merci de vérifier les informations saisies et de réessayer."
      },
      "emailNotConfirmed": {
        "title": "Email non confirmé",
        "message": "Un email de confirmation a été envoyé à l’inscription. Pour des raisons de sécurité, clique sur le lien de confirmation dans cet email avant de te connecter.\n\nPas reçu ? Pense à vérifier les courriers indésirables."
      },
      "userAlreadyRegistered": {
        "title": "Compte existant",
        "message": "Un compte existe déjà avec cette adresse e-mail. Connexion directe possible, ou utilise « Mot de passe oublié » si besoin."
      },
      "weakPassword": {
        "title": "Mot de passe trop faible",
        "message": "Pour des raisons de sécurité, le mot de passe doit contenir au moins 8 caractères, dont une majuscule, une minuscule et un chiffre."
      },
      "pwnedPassword": {
        "title": "Mot de passe trop courant",
        "message": "Ce mot de passe figure dans des fuites de données connues, il est donc facile à deviner. Choisis-en un autre : il peut suivre exactement les mêmes règles, il doit simplement être moins répandu."
      },
      "rateLimit": {
        "title": "Trop de tentatives",
        "message": "Pour des raisons de sécurité, les tentatives de connexion ont été temporairement bloquées. Patiente quelques minutes avant de réessayer."
      },
      "invalidEmail": {
        "title": "Email invalide",
        "message": "L’adresse e-mail saisie n’est pas valide. Merci de vérifier le format et de réessayer."
      },
      "userNotFound": {
        "title": "Compte introuvable",
        "message": "Aucun compte n’est associé à cette adresse e-mail. Envie de créer un nouveau compte ?"
      },
      "linkExpired": {
        "title": "Lien expiré",
        "message": "Ce lien a expiré pour des raisons de sécurité. Demande un nouveau lien de réinitialisation."
      },
      "network": {
        "title": "Problème de connexion",
        "message": "Impossible de se connecter au serveur. Merci de vérifier la connexion internet et de réessayer."
      },
      "accountExists": {
        "title": "Compte existant",
        "message": "Ces informations sont déjà associées à un compte. Merci de se connecter ou d’utiliser un autre email."
      },
      "invalidData": {
        "title": "Informations non valides",
        "message": "Certaines informations ne sont pas valides. Merci de vérifier les champs et de réessayer."
      },
      "accessDenied": {
        "title": "Accès refusé",
        "message": "Les autorisations nécessaires pour effectuer cette action sont manquantes."
      },
      "sessionExpired": {
        "title": "Session expirée",
        "message": "La session a expiré. Merci de se reconnecter pour continuer."
      },
      "signupFailed": {
        "title": "Inscription impossible",
        "message": "Impossible de créer le compte. Merci de vérifier les informations et de réessayer dans un instant."
      },
      "unknown": {
        "title": "Une erreur s’est produite",
        "message": "Quelque chose ne s’est pas passé comme prévu. Merci de réessayer dans un instant — si le problème persiste, contacter le support."
      },
      "profileDuplicate": {
        "title": "Informations déjà utilisées",
        "message": "Ces informations sont déjà utilisées par un autre compte. Veuillez utiliser des informations différentes."
      }
    },
    "moreInfo": "Plus d’informations",
    "plusPointsShort": "+{{points}} pts",
    "save": "Enregistrer",
    "confirm": "Confirmer",
    "delete": "Supprimer",
    "successTitle": "Succès",
    "pointsFull": "{{points}} points",
    "linkErrorTitle": "Impossible d’ouvrir le lien",
    "linkErrorMessage": "Aucune application disponible pour ouvrir ce lien.",
    "noEmailAppTitle": "Aucune application e-mail"
  },
  "dates": {
    "weekdayShort0": "Dim",
    "weekdayShort1": "Lun",
    "weekdayShort2": "Mar",
    "weekdayShort3": "Mer",
    "weekdayShort4": "Jeu",
    "weekdayShort5": "Ven",
    "weekdayShort6": "Sam",
    "month1": "janvier",
    "month2": "février",
    "month3": "mars",
    "month4": "avril",
    "month5": "mai",
    "month6": "juin",
    "month7": "juillet",
    "month8": "août",
    "month9": "septembre",
    "month10": "octobre",
    "month11": "novembre",
    "month12": "décembre",
    "challengeDayFormat": "{{weekday}}. {{day}} {{month}}",
    "challengeRangeSameMonth": "Du {{startDay}} au {{endDay}} {{month}}",
    "challengeRangeTwoMonths": "Du {{startDay}} {{startMonth}} au {{endDay}} {{endMonth}}",
    "todaySuffix": "(aujourd’hui)"
  },
  "login": {
    "welcomeTitle": "Bienvenue!",
    "emailPlaceholder": "Adresse e-mail",
    "passwordPlaceholder": "Mot de passe",
    "forgotPasswordLink": "Mot de passe oublié?",
    "loginButton": "Se connecter",
    "noAccountYet": "Pas encore de compte? ",
    "signUpLink": "S'inscrire",
    "emailNotConfirmedTitle": "Email non confirmé",
    "emailNotConfirmedMessage": "L'adresse email n'est pas encore confirmée. Renvoyer un email de confirmation ?",
    "resendEmailButton": "Renvoyer l'email",
    "resendEmailFailedRetry": "Impossible de renvoyer l'email. Réessayez plus tard.",
    "resendEmailFailed": "Impossible de renvoyer l'email.",
    "emailSentTitle": "Email envoyé ! ✉️",
    "confirmationEmailSentMessage": "Un nouvel email de confirmation a été envoyé à {{email}}. Pense à vérifier la boîte de réception (et les courriers indésirables).",
    "accountDeletedTitle": "Compte supprimé",
    "accountDeletedMessage": "Ce compte a été supprimé. En cas d'erreur, merci de contacter le support.",
    "resetEmailRequired": "Adresse e-mail requise",
    "emailInvalid": "Email invalide",
    "resetEmailSentMessage": "Un email a été envoyé avec un lien pour réinitialiser le mot de passe. Pense à vérifier la boîte de réception (et les courriers indésirables au besoin).",
    "forgotPasswordModalTitle": "Mot de passe oublié",
    "forgotPasswordModalDescription": "Saisis ton adresse e-mail pour recevoir un lien de réinitialisation du mot de passe."
  },
  "createAccount": {
    "companyPlaceholder": "Entreprise (facultatif)",
    "acceptTerms": "J’accepte les <termsLink>conditions générales</termsLink> et la <privacyLink>politique de confidentialité</privacyLink>",
    "alreadyRegistered": "Déjà inscrit? ",
    "emailExistsTitle": "Ce compte existe déjà",
    "emailExistsMessage": "Un compte est déjà associé à cette adresse e-mail. Connecte-toi pour continuer, ou utilise « Mot de passe oublié ? » si besoin.",
    "confirmEmailTitle": "Bienvenue dans REPAS challenge ! 🎉",
    "confirmEmailMessage": "Inscription presque finalisée !\n\nUn email de confirmation a été envoyé à {{email}}.\n\nClique sur le lien dans l’email, puis connecte-toi pour démarrer le défi REPAS.\n\nÀ noter : pense à vérifier les courriers indésirables si l’email n’apparaît pas.",
    "understoodButton": "J’ai compris !",
    "selectCompanyTitle": "Ton entreprise",
    "searchCompanyPlaceholder": "Ajouter ou rechercher une entreprise",
    "addCompany": "Ajouter « {{query}} »",
    "noCompanyFound": "Aucune entreprise trouvée. Saisis son nom pour l’ajouter.",
    "passwordValidator": {
      "minLength": "Au moins 8 caractères",
      "uppercase": "Au moins une majuscule",
      "lowercase": "Au moins une minuscule",
      "digit": "Au moins un chiffre",
      "secure": "Mot de passe sécurisé"
    }
  },
  "resetPassword": {
    "title": "Nouveau mot de passe",
    "subtitle": "Créez un nouveau mot de passe sécurisé",
    "newPasswordPlaceholder": "Nouveau mot de passe",
    "confirmPasswordPlaceholder": "Confirmer le mot de passe",
    "passwordMismatch": "Les mots de passe ne correspondent pas",
    "requirementsTitle": "Le mot de passe doit contenir :",
    "requirementMinLength": "• Au moins 8 caractères",
    "requirementUppercase": "• Une lettre majuscule",
    "requirementLowercase": "• Une lettre minuscule",
    "requirementDigit": "• Un chiffre",
    "submitButton": "Réinitialiser le mot de passe",
    "backToLogin": "Retour à la connexion",
    "linkExpiredTitle": "Lien expiré ⏱️",
    "linkExpiredMessage": "Ce lien de réinitialisation a expiré pour des raisons de sécurité.\n\nPas d’inquiétude ! Retournez sur l’écran de connexion et cliquez à nouveau sur « Mot de passe oublié ? » pour recevoir un nouveau lien.",
    "successTitle": "Mot de passe réinitialisé ! ✅",
    "successMessage": "Parfait ! Le mot de passe a été mis à jour avec succès.\n\nConnexion possible maintenant avec le nouveau mot de passe."
  },
  "confirmation": {
    "title": "Adresse confirmée ✅",
    "subtitle": "Ton adresse e-mail est validée. Connecte-toi pour participer au REPAS Challenge.",
    "loginButton": "Se connecter",
    "verifying": "Validation de ton adresse en cours…",
    "errorTitle": "Lien déjà utilisé ou expiré",
    "errorText": "Ce lien de confirmation n’est plus valable. Essaie quand même de te connecter : si ton adresse a déjà été validée, ça fonctionnera. Sinon, demande un nouvel email depuis l’écran de connexion."
  },
  "onboarding": {
    "dateRange": "DU 14 AU 25\nSEPTEMBRE 2026",
    "stepProgress": "Étape {{current}} sur {{total}}",
    "next": "Suivant",
    "start": "C’est parti !",
    "step1": {
      "title": "Bienvenue sur l’app du\nREPAS challenge !",
      "description": "Le défi pour une alimentation locale, équilibrée et sans déchet.",
      "credit": "Une action proposée par l’État de Genève en partenariat avec des organisations locales engagées."
    },
    "step2": {
      "title": "Des points chaque jour\net des prix à remporter !",
      "description": "Réaliser des actions, accomplir des missions et tenter la roue de la chance pour décrocher de nombreux cadeaux et prix.",
      "highlight": "Plus de CHF 5'000.- à gagner !"
    },
    "step3": {
      "title": "Plus qu’une étape :\ncréer un compte !",
      "description": "Dernière étape avant de tenter de gagner un premier prix, juste après l’inscription."
    }
  },
  "onboardingWheel": {
    "readyTitle": "Premier prix offert",
    "readySubtitle": "Fais tourner la roue : des points bonus et une participation au tirage au sort garantis.",
    "spinCta": "Tourne la roue",
    "spinning": "Ça tourne...",
    "doneTitle": "Bravo !",
    "doneSubtitle": "{{amount}} points crédités dès la création du compte, et une participation au tirage au sort offerte !",
    "bonusPointsPill": "⭐️ {{amount}} points",
    "bonusEntryPill": "🎁 Participation au tirage au sort",
    "formTitle": "Ton cadeau 🎁",
    "formSubtitle": "Indique ton adresse e-mail pour participer au tirage au sort. Plus de CHF 5'000.- à gagner !",
    "emailLabel": "Email",
    "emailPlaceholder": "nom@email.com",
    "emailAccessibilityLabel": "Adresse email",
    "emailInvalid": "Adresse e-mail invalide.",
    "formHint": "La participation sera enregistrée à la création du compte. Email utilisé uniquement pour le tirage au sort.",
    "submitButton": "Valider ma participation",
    "lockedTitle": "La roue ouvre le 14 septembre",
    "lockedSubtitle": "Tu pourras tourner la roue dès le début du défi. Crée ton compte maintenant pour être prêt.e.",
    "lockedCta": "Créer mon compte"
  },
  "notificationPermission": {
    "title": "Reste informé.e",
    "subtitle": "Active les notifications pour profiter pleinement de l’expérience REPAS",
    "benefitDailyTitle": "Rappel quotidien",
    "benefitDailyDescription": "Pour ne pas manquer les défis et les objectifs quotidiens",
    "benefitSuccessTitle": "Succès célébrés",
    "benefitSuccessDescription": "Notification dès qu’un objectif est atteint",
    "benefitCommunityTitle": "Challenges communautaires",
    "benefitCommunityDescription": "Info sur les nouveaux défis et événements",
    "benefitRewardsTitle": "Récompenses exclusives",
    "benefitRewardsDescription": "Découvre en avant-première les offres spéciales",
    "privacyNote": "Désactivable à tout moment.",
    "enableButton": "Active les notifications",
    "webTitle": "Bienvenue sur REPAS",
    "webSubtitle": "Tu peux participer au défi directement depuis ton navigateur.",
    "webBenefitTitle": "Version web",
    "webBenefitDescription": "Toutes les fonctionnalités du défi sont disponibles. Les rappels push ne le sont pas encore dans le navigateur.",
    "webPrivacyNote": "Ajoute cette page à l’écran d’accueil de ton iPhone pour y accéder facilement."
  },
  "rankingConsent": {
    "title": "Classement global",
    "subtitle": "Apparition dans le classement global de l’entreprise et de la communauté REPAS ?",
    "benefitProgressTitle": "Progrès visibles",
    "benefitProgressDescription": "Affichage du rang parmi les autres participants",
    "benefitMotivationTitle": "Motivation collective",
    "benefitMotivationDescription": "Comparaison avec les collègues pour rester motivé.e",
    "benefitAnonymousTitle": "Mode anonyme",
    "benefitAnonymousDescription": "En cas de refus, le classement reste visible sans y apparaître",
    "privacyNote": "Modifiable à tout moment dans les paramètres.",
    "acceptButton": "Oui, je veux apparaître",
    "declineButton": "Non, je reste invisible",
    "sessionExpiredTitle": "Session expirée",
    "sessionExpiredMessage": "Reconnecte-toi pour continuer.",
    "saveErrorMessage": "Impossible d’enregistrer ton choix. Vérifie ta connexion et réessaie."
  },
  "tabs": {
    "challenge": "Challenge",
    "missions": "Missions",
    "ranking": "Classement",
    "profile": "Profil"
  },
  "home": {
    "weeklyRecap": {
      "emptyTitle": "Aucune action validée pour l'instant",
      "emptySubtitle": "Valide tes premières actions dans l'onglet « Quotidien » : elles apparaîtront ici, cumulées sur toute la durée du challenge.",
      "seeProfileButton": "Voir mon profil",
      "bonusTitle": "Bonus",
      "completedLines_one": "Ligne complète : {{count}} × {{points}} pts",
      "completedLines_other": "Lignes complètes : {{count}} × {{points}} pts",
      "actionRow": "{{count}}× {{name}}",
      "totalLabel": "Total du challenge"
    },
    "tabDaily": "Quotidien",
    "tabWeekly": "Semaine",
    "title": "Tes actions",
    "streakDays_one": "{{count}} jour",
    "streakDays_other": "{{count}} jours",
    "streakA11y_one": "{{count}} jour consécutif",
    "streakA11y_other": "{{count}} jours consécutifs",
    "validateNotToday": "Validation uniquement le jour même",
    "validateWithBonus": "Valider ({{actionPoints}} + {{bonus}} bonus = {{total}} pts)",
    "validateWithPoints": "Valider ({{points}} points)",
    "saveFailedTitle": "Sauvegarde échouée",
    "saveFailedMessage": "Impossible d’enregistrer les actions. Merci de réessayer dans un instant.",
    "pointsNotCreditedTitle": "Points non crédités",
    "pointsNotCreditedMessage": "Les actions sont bien enregistrées, mais le crédit des points a échoué. Vérifie ta connexion — le total se resynchronisera au prochain chargement.",
    "actionInfo": {
      "learnMore": "Pour en savoir plus",
      "learnMoreWithLabel": "Pour en savoir plus : {{label}}"
    },
    "intro": {
      "title": "Bienvenue dans le défi REPAS !",
      "p1": "REPAS challenge, c’est 9 actions à réaliser d’ici le 25 septembre.",
      "p2": "Pour participer aux tirages au sort et gagner des cadeaux, il faut effectuer au minimum une action.",
      "p3": "Chaque action vaut des points. L’objectif est d’obtenir le plus de points et de réaliser les 9 actions.",
      "p4": "Chaque jour, des cadeaux sont mis en jeu avec la roue de la chance. Du lundi au vendredi, un quiz et une ressource à découvrir s’ajoutent.",
      "cta": "C’est parti !"
    }
  },
  "quiz": {
    "loading": "Chargement des missions…",
    "emptyTitle": "Aucune question",
    "emptyText": "Les questions seront bientôt disponibles !",
    "title": "Missions du challenge",
    "subtitle": "Réponds à la mission du jour !",
    "allDoneTitle": "Missions du jour réussies !",
    "allDoneText": "Toutes les missions du jour sont accomplies, bravo ! Rendez-vous au prochain jour de challenge.",
    "dayTitle": "Quiz du {{day}}",
    "bonusUpTo": "jusqu’à {{points}} pts bonus",
    "correctFeedback": "Bonne réponse ! +{{points}} pts",
    "incorrectFeedback": "Mauvaise réponse",
    "appToTest": "App à tester",
    "openAppA11y": "Ouvrir {{name}}",
    "markTestedA11y": "Marquer {{name}} comme testée",
    "alreadyTestedA11y": "{{name}} déjà testée",
    "alreadyTested": "Déjà testée",
    "iTested": "J’ai testé",
    "testedAlertTitle": "Bravo ! 🎉",
    "testedAlertMessage": "Merci d’avoir testé l’app du jour.\n\n+{{points}} pts",
    "card": {
      "stateCorrect": "Répondu correctement",
      "stateIncorrect": "Incorrect",
      "stateNotAnswered": "Pas répondu",
      "questionNumber": "Question n°{{number}}",
      "feedbackCorrect": "Bonne réponse !",
      "feedbackIncorrect": "Réponse incorrecte"
    },
    "siteToDiscover": "Site à découvrir",
    "iVisited": "J’ai consulté",
    "alreadyVisited": "Déjà consulté",
    "visitedAlertMessage": "Merci d’avoir consulté la ressource du jour.\n\n+{{points}} pts",
    "weekendTitle": "Pause week-end",
    "weekendText": "Pas de mission le samedi et le dimanche. Les actions quotidiennes, elles, restent ouvertes — rendez-vous lundi pour la suite."
  },
  "ranking": {
    "headerTitle": "Classement",
    "loading": "Chargement du classement...",
    "tabCompany": "Mon entreprise",
    "tabGlobal": "Global",
    "myPositionLabel": "Ma position",
    "noCompanyTitle": "Aucune entreprise",
    "noCompanyText": "Rejoins une entreprise pour voir le classement de tes collègues !",
    "chooseCompanyButton": "Choisir une entreprise",
    "emptyCompanyTitle": "Pas encore de participants",
    "emptyCompanyText": "Sois le premier à accumuler des points dans ton entreprise !",
    "globalSoonTitle": "Bientôt disponible",
    "globalSoonText": "Le classement global sera disponible très prochainement !",
    "waitingTitle": "Le classement ouvre le 14 septembre",
    "waitingText": "Tout le monde part de zéro. Les positions s’affichent dès le début du défi.",
    "waitingA11y": "Il reste {{days}} jours, {{hours}} heures, {{minutes}} minutes et {{seconds}} secondes.",
    "countdownDays": "j",
    "countdownHours": "h",
    "countdownMinutes": "min",
    "countdownSeconds": "s"
  },
  "profile": {
    "headerTitle": "Profil",
    "loadingProfile": "Chargement du profil...",
    "addFirstName": "Ajoute ton prénom",
    "totalPointsLabel": "Points totaux",
    "linkGifts": "Cadeaux",
    "linkPartners": "Partenaires",
    "linkAbout": "Notre démarche",
    "linkGoFurther": "Pour aller plus loin",
    "linkTerms": "Règles d’utilisation",
    "linkPrivacy": "Protection des données",
    "weeklyObjectiveTitle": "Ton objectif hebdo",
    "noObjectives": "Aucun objectif défini. Va dans « Tes actions » pour en choisir !",
    "currentMedalTitle": "Médaille actuelle",
    "medalBronze": "Bronze",
    "medalSilver": "Argent",
    "medalGold": "Or",
    "medalRangeBronze": "0-3 actions",
    "medalRangeSilver": "4-6 actions",
    "medalRangeGold": "7-9 actions"
  },
  "settings": {
    "headerTitle": "Préférences",
    "editProfile": "Modifier le profil",
    "notifications": "Notifications",
    "language": "Langue",
    "languageAuto": "Automatique",
    "languageAutoSubtext": "Langue de l’appareil",
    "languageFrench": "Français",
    "languageEnglish": "English",
    "rankingVisibility": "Apparaître dans le classement",
    "enabled": "Activé",
    "disabled": "Désactivé",
    "showRankingTitle": "Apparaître au classement",
    "hideRankingTitle": "Masquer du classement",
    "showRankingMessage": "Visibilité activée dans le classement de l’entreprise et de la communauté.",
    "hideRankingMessage": "Le classement reste consultable, mais sans apparition dedans.",
    "visibilityChangedTitle": "Modifié",
    "visibleInRanking": "Visible dans le classement",
    "hiddenFromRanking": "Masqué du classement",
    "visibilityError": "Impossible de modifier la visibilité",
    "reportBug": "Signaler un bug",
    "bugEmailSubject": "Signalement de bug - REPAS App",
    "bugEmailBody": "Bonjour,\n\nJe souhaite signaler le bug suivant :\n\n[Décrivez le problème ici]\n\n---\nInformations techniques :\n- Version app : {{appVersion}}\n- Plateforme : {{platform}}\n- Version OS : {{osVersion}}\n",
    "bugNoEmailAppMessage": "Impossible d’ouvrir la messagerie. Le signalement peut être envoyé à app@repaschallenge.ch.",
    "deleteAccountMenu": "Supprimer le compte et les données",
    "logout": "Se déconnecter",
    "fillAllFields": "Veuillez remplir tous les champs",
    "editNameTitle": "Modifier le nom",
    "nameUpdated": "Nom mis à jour avec succès",
    "nameUpdateError": "Impossible de mettre à jour le nom",
    "postalCodeLabel": "Code postal",
    "deleteAccountTitle": "Supprimer le compte",
    "deleteAccountMessage": "Conformément au RGPD et à la LPD suisse, toutes les données personnelles seront définitivement supprimées de nos serveurs.\n\nCette action est irréversible. Confirmer la suppression ?",
    "sessionError": "Impossible de récupérer la session",
    "accountDeletedTitle": "Compte supprimé",
    "accountDeletedMessage": "Le compte et les données personnelles ont été supprimés conformément au RGPD.",
    "deleteError": "Une erreur s’est produite lors de la suppression"
  },
  "notifications": {
    "headerTitle": "Notifications",
    "infoText": "Personnalise tes notifications pour rester motivé sans être dérangé",
    "typesTitle": "Types de notifications",
    "permissionWarningTitle": "Notifications désactivées",
    "permissionWarningText": "Active les notifications dans les paramètres de ton appareil pour recevoir les rappels.",
    "openSettings": "Ouvrir les paramètres",
    "quizTitle": "Quiz quotidien",
    "quizSubtext": "Chaque jour à 9h",
    "objectivesTitle": "Rappels objectifs",
    "objectivesSubtext": "3x par jour (10h30, 14h, 18h)",
    "wheelTitle": "Roue de la fortune",
    "wheelSubtext": "Chaque jour à 19h",
    "footerText": "Les notifications aident à rester engagé en rappelant de valider les actions quotidiennes.",
    "actionsTitle": "Actions",
    "reregisterToken": "Réenregistrer le token push",
    "sendTest": "Envoyer une notification de test",
    "updateError": "Impossible de mettre à jour les préférences",
    "tokenSavedTitle": "Succès ✅",
    "tokenSavedMessage": "Token push enregistré avec succès !",
    "tokenSaveError": "Impossible d’enregistrer le token",
    "tokenPermissionError": "Impossible d’obtenir le token. Les notifications doivent être activées dans les réglages de l’appareil.",
    "testSentTitle": "Envoyé ✅",
    "testSentMessage": "Une notification de test va arriver dans 2 secondes !",
    "testError": "Impossible d’envoyer la notification de test",
    "testPushTitle": "Test Notification 📬",
    "testPushBody": "Tes notifications fonctionnent !",
    "enableNow": "Activer les notifications"
  },
  "editProfile": {
    "headerTitle": "Modifier le profil",
    "imageHint": "Touchez pour changer la photo",
    "firstNameLabel": "Prénom *",
    "firstNamePlaceholder": "Prénom",
    "lastNameLabel": "Nom *",
    "lastNamePlaceholder": "Nom",
    "emailLabel": "Email *",
    "emailPlaceholder": "adresse@email.com",
    "emailHint": "Un email de confirmation sera envoyé en cas de changement d’adresse",
    "companyLabel": "Entreprise (facultatif)",
    "companyPlaceholder": "Nom de ton entreprise",
    "postalCodeLabel": "Code postal *",
    "selectPostalCode": "Sélectionner un code postal",
    "selectCompanyTitle": "Ton entreprise",
    "searchPostalCodePlaceholder": "Rechercher un code postal",
    "otherCantonTitle": "Autre canton",
    "noPostalCodeFound": "Aucun code postal trouvé",
    "searchCompanyPlaceholder": "Ajouter ou rechercher une entreprise",
    "addCompany": "Ajouter « {{query}} »",
    "companyAddError": "Impossible d’ajouter l’entreprise. Réessaie.",
    "noCompanyFound": "Aucune entreprise trouvée. Saisis son nom pour l’ajouter.",
    "saveButton": "Enregistrer les modifications",
    "unsupportedFormatTitle": "Format non supporté",
    "unsupportedFormatMessage": "Choisis une image au format JPG, PNG ou WEBP.",
    "imageTooLargeTitle": "Image trop volumineuse",
    "imageTooLargeMessage": "L’image doit faire moins de 5 Mo. Réduis sa taille et réessaie.",
    "uploadError": "Impossible d’uploader la photo",
    "uploadGenericError": "Une erreur s’est produite lors de l’upload",
    "fillRequiredFields": "Veuillez remplir tous les champs obligatoires",
    "photoUploadingTitle": "Photo en cours d’envoi",
    "photoUploadingMessage": "Patiente quelques secondes que la photo finisse de s’envoyer, puis réessaie.",
    "emailUpdateError": "Impossible de mettre à jour l’email : {{message}}",
    "emailUpdatedTitle": "Email mis à jour",
    "emailUpdatedMessage": "Un email de confirmation a été envoyé à la nouvelle adresse. Confirme-le pour finaliser le changement.",
    "profileUpdated": "Profil mis à jour avec succès",
    "profileUpdatedWithEmail": "Profil mis à jour. Un email de confirmation a été envoyé à la nouvelle adresse : confirme-le pour finaliser le changement.",
    "profileUpdateError": "Impossible de mettre à jour le profil",
    "genericError": "Une erreur s’est produite"
  },
  "editObjectives": {
    "title": "Objectif à choisir",
    "subtitle": "Définir son impact : sélectionner les actions à réaliser chaque jour.",
    "bronzeTitle": "Bronze : en douceur",
    "bronzeRange": "1 à 3 actions",
    "silverTitle": "Argent : engagement",
    "silverRange": "4 à 6 actions",
    "goldTitle": "Or : grande implication",
    "goldRange": "7 à 9 actions"
  },
  "wheel": {
    "title": "Roue de la chance",
    "subtitle": "Tirage au sort quotidien",
    "spinCta": "Tourne la roue",
    "spinning": "Ça tourne…",
    "pointsUnit": "pts",
    "disclaimer": "Jeu-concours organisé par l’État de Genève. Une participation par jour. Apple et Google n’en sont pas sponsors.",
    "wonTitle": "Bravo, c’est gagné !",
    "wonTitleA11y": "Bravo, qualification pour le tirage au sort",
    "formSubtitleExtraInfo": "Tu peux participer au tirage au sort du jour. Encore deux infos pour pouvoir te remettre le cadeau en cas de gain.",
    "formSubtitleConfirmEmail": "Tu peux participer au tirage au sort du jour. Confirme ton adresse e-mail pour être contacté.e en cas de gain.",
    "ageLabel": "Âge",
    "agePlaceholder": "Ex. 32",
    "genderLabel": "Genre",
    "gender": {
      "femme": "Femme",
      "homme": "Homme",
      "autre": "Autre",
      "prefereNePasDire": "Préfère ne pas dire"
    },
    "emailLabel": "Email",
    "emailPlaceholder": "nom@email.com",
    "emailA11y": "Adresse email",
    "submitCta": "Confirmer ma participation",
    "errors": {
      "ageRange": "L’âge doit être compris entre 13 et 120 ans.",
      "genderRequired": "Le genre est requis.",
      "profileSaveFailed": "Impossible d’enregistrer les informations. Merci de réessayer.",
      "invalidEmail": "Email invalide.",
      "consentRequired": "L’acceptation d’être contacté est requise pour participer.",
      "alreadyEntered": "Participation déjà enregistrée pour ce compte.",
      "notAuthenticated": "Connexion requise pour participer.",
      "generic": "Une erreur est survenue, merci de réessayer."
    },
    "doneTitle": "Participation enregistrée",
    "doneSubtitlePrefix": "Qualification confirmée pour le tirage au sort. En cas de gain, contact via",
    "accountEmailFallback": "l’email du compte",
    "wonPointsPill": "+{{points}} points",
    "wonPointsSubtitle": "{{points}} points ont été ajoutés au total. Reviens demain pour retenter la roue.",
    "wonPointsCta": "Super !",
    "spentTitle": "Roue déjà tournée",
    "spentSubtitle": "Une participation par jour. Reviens demain pour faire tourner la roue à nouveau.",
    "lockedTitle": "La roue ouvre le 14 septembre",
    "lockedSubtitle": "Le tirage au sort commence avec le défi. Reviens lundi pour faire tourner la roue.",
    "lockedCta": "Compris",
    "closeA11y": "Fermer la fenêtre"
  },
  "celebration": {
    "title": "Félicitations !",
    "homeLink": "Accueil",
    "allDoneTitle": "Toutes les actions sont faites !",
    "allDoneText": "Les 9 actions ont été réalisées aujourd’hui, bravo ! Le défi se poursuit demain.",
    "resultsTitle": "Résultats",
    "totalPointsLabel": "Points totaux",
    "bonusLabel": "Bonus loto (ligne complète)",
    "bonusValue": "+{{points}} points",
    "zeroWasteLabel": "Points zéro déchet",
    "balancedLabel": "Points alimentation équilibrée",
    "localLabel": "Points alimentation locale",
    "weeklyActivityTitle": "Activité de la semaine",
    "medalsTitle": "Médailles obtenues",
    "medalBronze": "Bronze",
    "medalSilver": "Argent",
    "medalGold": "Or",
    "medalRangeBronze": "0-9 actions",
    "medalRangeSilver": "10-49 actions",
    "medalRangeGold": "50+ actions"
  },
  "goFurther": {
    "headerTitle": "Pour aller plus loin",
    "intro": "Voici des informations et des conseils concrets pour adopter des habitudes plus responsables au quotidien.",
    "consommactionSectionTitle": "Guide Consomm’action",
    "consommactionPageTitle": "Page Consomm’action",
    "consommactionPageDescription": "Découvre le guide complet pour une consommation responsable",
    "eatSheetTitle": "Fiche complète : SE NOURRIR",
    "eatSheetDescription": "Tout savoir sur l’alimentation durable",
    "reusableSectionTitle": "Vaisselle réutilisable",
    "reusableSectionText": "Pour tout savoir sur la vaisselle réutilisable dans le canton de Genève :",
    "emportonsMalinTitle": "Emportons Malin",
    "emportonsMalinDescription": "Guide de la vaisselle consignée et carte des restaurants",
    "engageSectionTitle": "S’engager pour un avenir durable",
    "ecoDefisTitle": "Éco-défis",
    "ecoDefisDescription": "Participe aux défis écologiques du canton",
    "climateTitle": "Nos Gestes Climat",
    "climateDescription": "Calcule ton empreinte carbone avec Nos Gestes Climat",
    "datesSectionTitle": "Dates à retenir",
    "tasteWeekTitle": "Semaine suisse du Goût",
    "tasteWeekDescription": "Du 17 au 27 septembre 2026",
    "foodWasteWeekTitle": "Semaine contre le gaspillage alimentaire",
    "foodWasteWeekDescription": "Du 12 au 20 septembre 2026",
    "questionTitle": "Une question ?",
    "contactButton": "Nous contacter",
    "noEmailAppMessage": "Impossible d’ouvrir la messagerie. Contact possible à app@repaschallenge.ch."
  },
  "partners": {
    "headerTitle": "Partenaires",
    "intro": "Le défi REPAS challenge est une action proposée par l’État de Genève en partenariat avec plusieurs acteurs engagés pour une alimentation locale, équilibrée et sans déchet.",
    "openPartnerSite": "Ouvrir le site de {{name}}"
  },
  "gifts": {
    "headerTitle": "Cadeaux",
    "intro": "REPAS challenge : plus de CHF 5’000 de prix à gagner ! Des cadeaux sont mis en jeu tous les jours ouvrables.",
    "drawsTitle": "Tirages au sort",
    "drawsText": "Les tirages au sort sont réalisés par l’équipe REPAS challenge. Les gagnant.e.s sont informé.e.s par e-mail."
  },
  "about": {
    "headerTitle": "Notre démarche",
    "introPrefix": "REPAS challenge est un",
    "introLink": "éco-défi",
    "introSuffix": "proposé par l’État de Genève pour promouvoir une alimentation locale, équilibrée et sans déchet.",
    "paragraphAudience": "Cette action est ouverte à toutes les organisations mais aussi à toutes les personnes qui vivent, qui travaillent ou qui transitent à Genève.",
    "paragraphAxes": "REPAS challenge est un challenge simple et ludique sur trois axes et pour promouvoir neuf comportements :",
    "bulletLocal": "Alimentation locale : pour encourager l’achat et la consommation de produits locaux et de saisons",
    "bulletBalanced": "Alimentation équilibrée : pour promouvoir une alimentation saine",
    "bulletZeroWaste": "Alimentation sans déchet : pour réduire le gaspillage alimentaire et trier les déchets.",
    "howTitle": "Comment ça marche ?",
    "howText": "C’est très simple ! Chaque jour, il suffit de sélectionner, parmi les neuf actions proposées, celles qui ont été réalisées. Chaque action rapporte des points. Quand une série est faite (toutes les actions d’un des axes), des points bonus sont offerts. Si toutes les actions sont réalisées… c’est gagné !",
    "contactTitle": "Nous contacter",
    "contactText": "Pour toute question : GE - Eco-défis (DT)"
  },
  "rules": {
    "headerTitle": "Règles d’utilisation",
    "lastUpdate": "Dernière mise à jour : septembre 2026",
    "section1Title": "1. Présentation",
    "section1Body": "REPAS challenge est une application gratuite proposée par l’État de Genève. Elle vise à encourager des habitudes alimentaires durables et responsables au quotidien.",
    "section2Title": "2. Gratuité",
    "section2Body": "L’utilisation de REPAS challenge est entièrement gratuite. Aucun achat in-app n’est proposé.",
    "section3Title": "3. Inscription",
    "section3Body": "L’inscription nécessite une adresse email valide. La confidentialité des identifiants de connexion relève de la responsabilité de l’utilisateur-trice.",
    "section4Title": "4. Règles d’utilisation",
    "section4Intro": "L’utilisation de REPAS implique de :",
    "section4Bullet1": "Utiliser l’application de manière honnête et loyale",
    "section4Bullet2": "Ne pas créer plusieurs comptes pour une même personne",
    "section4Bullet3": "Déclarer uniquement les actions réellement effectuées",
    "section4Bullet4": "Respecter les autres participant.e.s",
    "section5Title": "5. Fair-play et modération",
    "section5Body": "REPAS challenge repose sur la confiance et l’engagement de chacun.e. L’État de Genève se réserve le droit de suspendre ou supprimer tout compte dont l’utilisation serait jugée contraire à l’esprit du projet ou aux présentes conditions.",
    "section6Title": "6. Classement et prix",
    "section6Body1": "La participation au classement est optionnelle. La visibilité peut être modifiée à tout moment dans les paramètres.",
    "section6Body2": "Pendant le challenge, des prix seront attribués aux participant.e.s par tirage au sort (cf. rubrique Les cadeaux).",
    "section6Body3": "Les points n’ont aucune valeur monétaire et les récompenses ne peuvent être échangées contre de l’argent ou des biens.",
    "section6Body4": "Le jeu-concours (roue de la chance et tirage au sort) est organisé par l’État de Genève. Il est ouvert aux personnes de 13 ans et plus, à raison d’une participation par jour. Apple et Google ne sont ni sponsors ni organisateurs de ce jeu-concours et n’y sont impliqués d’aucune manière.",
    "section7Title": "7. Propriété intellectuelle",
    "section7Body": "L’application REPAS challenge, son contenu et son design sont la propriété de l’État de Genève. Toute reproduction non autorisée est interdite.",
    "section8Title": "8. Limitation de responsabilité",
    "section8Body": "L’État de Genève met tout en œuvre pour assurer le bon fonctionnement de l’application mais ne peut garantir une disponibilité permanente. L’utilisation de l’application se fait sous la responsabilité de l’utilisateur-trice.",
    "section9Title": "9. Modifications",
    "section9Body": "Ces conditions peuvent être modifiées à tout moment. Les utilisateurs-trices seront informé.e.s des changements importants.",
    "section10Title": "10. Droit applicable",
    "section10Body": "Les présentes conditions sont soumises au droit suisse. Tout litige relève de la compétence exclusive des tribunaux genevois."
  },
  "privacy": {
    "headerTitle": "Politique de confidentialité",
    "lastUpdate": "Dernière mise à jour : septembre 2026",
    "section1Title": "1. Responsable du traitement",
    "section1Body": "REPAS challenge est une démarche de l’État de Genève visant à encourager des habitudes alimentaires durables. Les données sont hébergées en Suisse.",
    "section2Title": "2. Données collectées",
    "section2Intro": "Nous collectons uniquement les données nécessaires au fonctionnement de l’application :",
    "section2Bullet1": "Informations de compte (prénom, nom, email, etc.)",
    "section2Bullet2": "Code postal et entreprise (optionnel)",
    "section2Bullet3": "Actions quotidiennes enregistrées",
    "section2Bullet4": "Points et progression",
    "section3Title": "3. Utilisation des données",
    "section3Intro": "Les données collectées sont utilisées exclusivement pour :",
    "section3Bullet1": "Le fonctionnement de l’application et les tirages au sort des cadeaux",
    "section3Bullet2": "L’affichage du classement",
    "section3Bullet3": "Des statistiques anonymisées à des fins d’amélioration",
    "section3Emphasis": "Aucun suivi publicitaire n’est effectué et aucune donnée n’est vendue. Certaines données sont traitées par nos sous-traitants techniques — Supabase (hébergement, Suisse), Amplitude (statistiques d’usage) et Sentry (rapports d’erreur) — uniquement pour faire fonctionner et améliorer l’application.",
    "section4Title": "4. Hébergement et sécurité",
    "section4Body": "Toutes les données sont stockées sur des serveurs sécurisés situés en Suisse. Les communications sont chiffrées via HTTPS.",
    "section5Title": "5. Droits de l’utilisateur",
    "section5Intro": "Conformément à la loi suisse sur la protection des données (LPD), il est possible de :",
    "section5Bullet1": "Accéder aux données via le profil",
    "section5Bullet2": "Modifier les informations à tout moment",
    "section5Bullet3": "Supprimer le compte et les données dans les paramètres",
    "section6Title": "6. Conservation des données",
    "section6Body": "Les données sont conservées tant que le compte est actif. En cas de suppression, les données sont anonymisées pour conserver l’intégrité des statistiques globales.",
    "section7Title": "7. Contact",
    "section7Body": "Pour toute question relative aux données, contact via l’application ou sur repaschallenge.ch"
  },
  "actions": {
    "categories": {
      "local": "Alimentation locale",
      "balanced": "Alimentation équilibrée",
      "zeroWaste": "Zéro déchet"
    },
    "grta": {
      "name": "Produits GRTA",
      "description": "Pour gagner, il suffit de manger un produit GRTA (Genève Région Terre Avenir).",
      "infoLabel": "Le portail du terroir genevois"
    },
    "ambassadeurs": {
      "name": "Ambassadeurs du terroir",
      "description": "Pour gagner, il suffit de manger chez un Ambassadeur du terroir.",
      "infoLabel": "Ambassadeurs du Terroir"
    },
    "venteFerme": {
      "name": "Vente à la ferme",
      "description": "Pour gagner, il suffit de manger un produit acheté dans un point de vente de proximité.",
      "infoLabel": "Points de vente de produits du terroir"
    },
    "repasEquilibre": {
      "name": "Repas équilibré",
      "description": "Pour gagner, il suffit de manger un repas équilibré qui respecte la pyramide alimentaire suisse.",
      "infoLabel": "Société Suisse de Nutrition"
    },
    "nutriScore": {
      "name": "Nutri-Score",
      "description": "Pour gagner, il suffit de manger un produit avec un Nutri-score A.",
      "infoLabel": "Nutri-Score"
    },
    "proteineVegetale": {
      "name": "Protéine végétale",
      "description": "Pour gagner, il suffit de manger une protéine végétale qui remplace de la viande/poisson/œuf.",
      "infoLabel": "Fourchette verte Genève"
    },
    "contenantReutilisable": {
      "name": "Contenant réutilisable",
      "description": "Pour gagner, il suffit de manger un repas dans un contenant réutilisable : tupperware, box reCIRCLE, assiette ou bol.",
      "infoLabel": "Emportons malin !"
    },
    "compost": {
      "name": "Compost",
      "description": "Pour gagner, il suffit de mettre les déchets de cuisine dans un compost.",
      "infoLabel": "Déchets de cuisine"
    },
    "pasDeGaspillage": {
      "name": "Pas de gaspillage",
      "description": "Pour gagner, il suffit de manger un repas sans gaspillage.",
      "infoLabel": "Gaspillage alimentaire"
    }
  },
  "apps": {
    "yuka": {
      "tagline": "Scanner ses produits et décrypter leur composition"
    },
    "myswissfood": {
      "tagline": "Apprendre plus sur une alimentation équilibrée, variée et savoureuse"
    },
    "toogoodtogo": {
      "tagline": "Sauver des repas du gaspillage à petit prix"
    },
    "frigomagic": {
      "tagline": "Des recettes rapides et personnalisées selon les ingrédients de ton frigo"
    },
    "nosgestesclimat": {
      "tagline": "Calculer son empreinte carbone et obtenir des pistes pour la réduire"
    },
    "vaisselle": {
      "tagline": "Informations et conseils sur la vaisselle réutilisable"
    },
    "geneveterroir": {
      "tagline": "Découvrir le terroir et les produits genevois"
    },
    "poubelleverte": {
      "tagline": "Informations sur le tri des déchets de cuisine à Genève"
    },
    "calendriersaisons": {
      "tagline": "Les fruits, légumes et herbes de saison en Suisse"
    }
  }
}
